import { z } from 'zod'

import { StringDtoSchema } from '@hcr/api/shared'

export const CardDtoBaseSchema = z.strictObject({
  description: StringDtoSchema,
})
